// extracted by mini-css-extract-plugin
export default {"outerWrap":"mainLayout_outerWrap__EHEDz","innerWrap":"mainLayout_innerWrap__08VRm","aside":"mainLayout_aside__9JvgQ"};